import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { BaseBox, IBase } from '@docon/docon-ui-library';

interface IProps extends IBase {
  href: string;
  download?: string;
}

function DownloadLink({ ...props }: IProps) {
  const ref = useRef<any>();

  useEffect(() => {
    if (props.href) {
      ref.current.click();
    }
  }, [props.href]);

  return (
    <BaseBox as='a' ref={ref} {...props} />
  );
}
export default styled(DownloadLink)``;